import React, { FC, memo, useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  useGetNotificationsQuery,
  useUpdateNotificationMutation,
} from "~/schemas/generated/graphql";
import { NOTIFICATIONS } from "~/constans/notifications";

import NotificationRight from "~/components/Notifications/NotificationRight";
import NotificationsMessage from "./NotificationsMessage";
import Body from "./Body";

const Notifications: FC = () => {
  const { t } = useTranslation();
  const [updateNotificationMutation] = useUpdateNotificationMutation({});
  const {
    data: { getNotifications },
  } = useGetNotificationsQuery();
  const notifications = useMemo(
    () =>
      getNotifications.filter(
        ({ type, isOpen }) => type === NOTIFICATIONS.report && isOpen
      ),
    [getNotifications]
  );

  const onGenerate = (id) => {
    updateNotificationMutation({
      variables: {
        id,
        isOpen: false,
      },
    });
  };

  return (
    <>
      <NotificationsMessage />
      {notifications.length > 0 && (
        <NotificationRight title={t("common.downloading")}>
          <Body items={notifications} onClickIcon={onGenerate} />
        </NotificationRight>
      )}
    </>
  );
};

export default memo(Notifications);
